import React from "react";
import { useNavigate } from 'react-router-dom';
import ListVpsUsExpirePage from "../ListVpsUsExpirePage";

const PageListVpsUsExpire = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-vps-us/chuyen-khach-hang.html?' + listVps);
    }

    return <ListVpsUsExpirePage
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
    />

}

export default PageListVpsUsExpire;